<template>
  <div class="mr-2">
    <v-btn
      icon
      color="white"
      @click="generateReport()"
    >
      <v-icon>mdi-file-pdf-box</v-icon>
    </v-btn>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Formato ISE"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :html-to-pdf-options="options"
    >
      <section slot="pdf-content">
        <section class="pdf-item">
          <v-container class="margin">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="6">
                    <img
                      src="@/assets/img/logo-puebla.png"
                      width="100%"
                      alt="img"
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>DEPARTAMENTO DE INVESTIGACIÓN SOCIOECONÓMICA<br>Informe</th>
                      </tr>
                    </thead>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>DATOS PERSONALES</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="9">
                              <v-row>
                                <v-col cols="6">
                                  Nombre: {{ getFullName(evaluacion.Derivacion.Programacion
                                    .Expediente.Personal) }}
                                </v-col>
                                <v-col cols="4">
                                  Edad:
                                  {{ getAge(evaluacion.Derivacion.Programacion.Expediente
                                    .Personal.fechaNacimiento) }} años
                                </v-col>
                                <v-col cols="2">
                                  Género: {{ evaluacion.Derivacion.Programacion.Expediente
                                    .Personal.CatSexo.title }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="8">
                                  Institución:
                                  {{ evaluacion.Derivacion.Programacion.Expediente
                                    .Personal.unidadAnalisisTactico }}
                                </v-col>
                                <v-col cols="4">
                                  Folio: {{ evaluacion.Derivacion.Programacion.Expediente.folio }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="8">
                                  Puesto funcional:
                                  {{ evaluacion.Derivacion.Programacion.Expediente
                                    .Personal.unidadOperaciones }}
                                </v-col>
                                <v-col cols="4">
                                  RFC: {{ evaluacion.Derivacion.Programacion
                                    .Expediente.Personal.rfc }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="6">
                                  Escolaridad:
                                </v-col>
                                <v-col
                                  v-if="evaluacion.Derivacion.Programacion.CatMotivoEvaluacion"
                                  cols="6"
                                >
                                  Motivo de evaluación: {{ evaluacion.Derivacion
                                    .Programacion.CatMotivoEvaluacion.title }}
                                </v-col>
                                <v-col
                                  v-else
                                  cols="6"
                                >
                                  Motivo de evaluación: NO REGISTRADO
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="7">
                                  Antigüedad: {{ evaluacion.Derivacion.Programacion
                                    .Expediente.antiguedadInstitucion }} años
                                </v-col>
                                <v-col cols="5">
                                  Fecha de evaluación:
                                  {{ getDate(evaluacion.Derivacion.Programacion
                                    .fechaEvaluacionPsicologica) }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  Funciones:
                                  {{ evaluacion.Derivacion.Programacion.Expediente
                                    .Personal.unidadInvestigacion }}
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="3">
                              <img
                                :src="evaluacion.Derivacion.Programacion.Expediente.Personal.foto"
                                crossorigin="anonymous"
                                width="100%"
                                alt="img"
                              >
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>ANÁLISIS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              {{ evaluacion.analisis }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </section>
        <div class="html2pdf__page-break" />
        <section class="pdf-item">
          <v-container class="margin">
            <v-row>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>CONTINUACIÓN DEL INFORME DE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="3">
                              DIAGNÓSTICO PRELIMINAR:
                            </v-col>
                            <v-col cols="9">
                              {{ evaluacion.CatDiagnostico.title }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>SÍNTESIS TÉCNICA</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              {{ evaluacion.sintesisTecnica }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>DATOS RELEVANTES</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              {{ evaluacion.observaciones }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="6">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>ELABORÓ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td />
                      </tr>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              Evaluador {{ evaluacion.CatEvaluador.evaluador }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="6">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>REVISÓ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td />
                      </tr>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              Jefe de departamento {{ evaluacion.CatSupervisor.evaluador }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col
                cols="12"
                class="font mt"
              >
                Toda la información contenida en el presente documento
                está catalogada como CONFIDENCIAL de conformidad con la normatividad
                aplicable en los Artículos 3 Fracción II y 18 de la Ley Federal
                de Transparencia y Acceso a la Información Pública
                Gubernamental y por el Artículo 25 de la Ley de Acceso a la Información
                Pública y Protección de Datos Personales para el
                Estado de Morelos.
              </v-col>
            </v-row>
          </v-container>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment';

export default {
  components: {
    VueHtml2pdf,
  },

  props: {
    evaluacion: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      options: {
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: false,
        },
        margin: [8, 0, 8, 0],
      },
    };
  },

  methods: {
    /*
            Generate Report using refs and calling the
            refs function generatePdf()
        */
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    getDate(fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },
  },
};
</script>

<style scoped>
    .font {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
    }
    th,
    tr {
        border: 1px solid;
    }
    .logo {
        border: 1px solid;
        height: 80px;
    }
    .mt {
        margin-top: 100px;
    }
    .margin {
        padding: 8px 48px 8px 48px;
    }
</style>
